@if (emailMessage) {
  <div>
    <ul class="list-group">
      <li class="list-group-item">
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <div class="pt-2 pb-2">
              To:
              @for (element of emailMessage.to; track element; let isLast = $last) {
                <span class="user-email">
                  {{element}}{{isLast ? '' : ', '}}
                </span>
              }
            </div>
            @if (emailMessage.cc.length) {
              <div class="pt-2 pb-2">
                Cc:
                @for (element of emailMessage.cc; track element; let isLast = $last) {
                  <span class="user-email">
                    {{element}}{{isLast ? '' : ', '}}
                  </span>
                }
              </div>
            }
            @if (emailMessage.bcc.length) {
              <div class="pt-2 pb-2">
                Bcc:
                @for (element of emailMessage.bcc; track element; let isLast = $last) {
                  <span class="user-email">
                    {{element}}{{isLast ? '' : ', '}}
                  </span>
                }
              </div>
            }
          </div>
          <div class="col-sm-12 col-md-5">
            <div class="pt-2 pb-2">
              Status: <strong>{{ emailMessage.status }}</strong>
            </div>
            <div class="pt-2 pb-2">
              Retry Count: <strong>{{ emailMessage.retryCount }}</strong>
            </div>
            @if (emailMessage.status === 'Sent') {
              <div class="pt-2 pb-2">
                Date Sent: <strong>{{ emailMessage.messageSentOn | date:'short' }}</strong>
              </div>
            }
            <div class="pt-2 pb-2">
              Service: <strong>{{ getServiceName(emailMessage.serviceCategory === null ? -1 : emailMessage.serviceCategory.serviceType) }}</strong>
            </div>
            <div class="pt-2 pb-2" >
              Category: @for (item of emailMessage.serviceCategory?.categories; track item; let isLast = $last) {
              <strong>{{ item.category }}@if (!isLast) {
                <span>, </span>
              }</strong>
            }
          </div>
        </div>
        <div class="col-sm-6 col-md-3">
          <table class="table table-bordered ">
            <thead>
              <tr>
                <th scope="col">Timestamp</th>
                <th scope="col">Event/Status</th>
              </tr>
            </thead>
            <tbody>
              @for (status of emailMessage.providerResponse?.statuses; track status) {
                <tr>
                  <td>{{ status?.receivedOn | date:'short'}}</td>
                  <td>{{ status?.status }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </li>
    <li class="list-group-item">
      <div>
        Subject: <strong>{{ emailMessage.subject }}</strong>
      </div>
    </li>
    <li class="list-group-item message-body">
      <div >
        Body: <p [innerHTML]="emailMessage.body"></p>
      </div>
    </li>
  </ul>
</div>
}